<template>
  <header class="header" :class="[{ 'is-active--nav': isActiveNav }, { 'is-loaded--header': isLoaded }]">
    <div class="header__dimmer" @click="handleHolder"></div>
    <div class="vn-grid-medium">
      <h1 class="header__title">
        <a href="/" class="header__link">
          <icon-logo class="header__logo" />
          <span class="a11y">Fast Campus</span>
        </a>
      </h1>

      <button type="button" class="nav-opener" @click="handleHolder">
        <icon-menu />
      </button>

      <div class="nav-holder" @scroll="handleMenuAside">
        <menu-aside :is-active-aside="isActiveAside" @emit-holder="handleHolder" />

        <common-utils
          :user-name="userName"
          :is-authorized="isAuthorized"
          :is-active-holder="isActiveHolder"
          @emit-sign-in="handleSignIn"
          @emit-sign-up="handleSignUp"
          @emit-holder="handleHolder"
        />

        <global-navigation :nav="nav" :is-active-nav="isActiveNav" @emit-header="handleHeader" />
      </div>
    </div>
  </header>
</template>

<script>
import { initTrackers } from '@fastcampus/tracker/index';

import GlobalNavigation from './components/global-navigation';
import CommonUtils from './components/common-utils';
import MenuAside from './components/menu-aside';

import IconLogo from './components/icons/logo.svg';
import IconMenu from './components/icons/menu.svg';

import { debounce } from './mixins';

import auth from '../auth';

import api from '../api';

export default {
  mixins: [auth, debounce],
  props: ['nav', 'design-theme', 'assets'],
  components: {
    GlobalNavigation,
    MenuAside,
    CommonUtils,
    IconLogo,
    IconMenu,
  },
  created() {
    this.setNavigation();
    this.getAuthorized();
    if (this.isAuthorized) {
      this.getUserName();
    }
  },
  mounted() {
    const body = document.querySelector('body');
    this.theme = this.designTheme;
    this.isLoaded = true;
    if (this.theme) {
      body.classList.add(`fc-theme--${this.theme.toLowerCase().replace('_', '-')}`);
    }
    initTrackers({ context: window, scope: 'www', options: { userId: this.userId, customerId: this.customerId } });
  },
  data() {
    return {
      isLoaded: false,
      isActiveNav: false,
      isActiveHolder: false,
      isActiveAside: false,
      theme: null,
      userName: '',
      userId: '',
      customerId: '',
      gnb: [],
    };
  },
  methods: {
    handleSignIn() {
      this.authorize('signIn');
      if (this.isAuthorized) {
        this.getUserName();
      }
    },
    handleSignUp() {
      this.getSignUpUrl();
    },
    handleHeader(state) {
      this.isActiveNav = state;
    },
    handleMenuAside(e) {
      const sideTop = e.target.querySelector('.nav-aside');
      this.isActiveAside = !!sideTop.offsetTop;
    },
    handleHolder() {
      const body = document.querySelector('body');
      this.isActiveHolder = !this.isActiveHolder;
      body.classList.toggle('is-active--holder');
    },
    setNavigation() {
      this.gnb = this.nav;
    },
    getAuthorized() {
      this.authorize();
      if (this.isAuthorized && this.$route.hash) {
        this.$router.push({ path: this.$route.path });
      }
    },
    async getUserName() {
      try {
        const {
          data: {
            data: { userName, id, userId, customerId },
          },
        } = await api.getUser();
        this.userName = userName;
        this.userId = id || userId;
        this.customerId = customerId;
      } catch (err) {
        if (err.message === 'UNAUTHORIZED') {
          this.signIn();
        } else {
          this.rejectAuthorize();
        }
      }
    },
  },
};
</script>
